/* Next10 — botao de fechar do menu mobile.
   Roda na fase de captura para nao cair no handler padrao do Dawn,
   que fecha apenas o submenu e deixaria o body travado. */
document.addEventListener(
  'click',
  function (event) {
    if (!event.target.closest) return;
    var botao = event.target.closest('.n10-drawer__close');
    if (!botao) return;

    var drawer = botao.closest('header-drawer, menu-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;

    event.preventDefault();
    event.stopPropagation();
    drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
  },
  true
);
